//import ProductTempleteSR from "../templates/product-templete-seco";
//import { Rishab } from '../data/products'
function ProductRishab() {
    return  (
        <>
            {/* <ProductTempleteSR data = { Rishab }/> */}
        </>
    )
}

export default ProductRishab;